export const Flag = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="52"
    viewBox="0 0 46 52"
    fill="none"
  >
    <path
      d="M7.68696 25.1756C7.53221 25.8475 7.18766 26.6693 5.75102 28.0504C6.5876 37.9338 37.3014 30.3758 35.8145 29.0923C34.625 28.0655 33.4075 26.1709 33.3283 25.5135C29.9837 25.8939 27.471 24.0746 25.6499 22.1148C21.8721 25.0258 17.2847 23.8553 15.7833 22.4191C14.1746 24.9514 10.9238 26.5811 7.68696 25.1756Z"
      fill="#06FFC3"
    />
    <path
      d="M1.89206 30.3152L0 36.477L3.78411 37.0695L15.7277 47.7341L21.9951 46.1937L26.134 52L40.9157 42.6388L40.2062 40.0319L45.8824 35.529L44.6998 31.7371C41.507 29.7227 32.4015 25.6938 21.5221 25.6938C10.6428 25.6938 3.90237 28.7747 1.89206 30.3152Z"
      fill="#144DFF"
    />
    <path
      d="M35.4685 38.3208L22.9412 47.9426L25.8957 52L40.6685 42.8419L39.9594 40.2915L37.3594 42.1463L37.8321 39.596L35.4685 38.3208Z"
      fill="#003CD3"
    />
    <path
      d="M7.85449 34.6377L5.73529 36.6054L16.6845 46.2124L14.5653 37.2998L12.2106 38.2258L7.85449 34.6377Z"
      fill="#003CD3"
    />
    <path
      d="M38.5829 21.485C37.2411 21.7171 37.0264 21.9028 36.758 23.0634C36.4897 21.9028 36.275 21.7171 34.9332 21.485C36.275 21.2529 36.4897 21.0672 36.758 19.9066C37.0264 21.0672 37.2411 21.2529 38.5829 21.485Z"
      fill="#00B7FF"
    />
    <path
      d="M15.1203 16.4866C14.3536 16.6026 14.2309 16.6955 14.0775 17.2758C13.9242 16.6955 13.8015 16.6026 13.0348 16.4866C13.8015 16.3705 13.9242 16.2777 14.0775 15.6974C14.2309 16.2777 14.3536 16.3705 15.1203 16.4866Z"
      fill="#00B7FF"
    />
    <rect
      x="20.3342"
      y="0.965973"
      width="2.08556"
      height="28.9368"
      fill="#003CD3"
    />
    <g clipPath="url(#clip0_4095_157324)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-23.0656 -22.8483L-16.1502 50.0177C-16.1502 50.0177 0.446093 57.3298 33.1525 45.7157C69.3195 32.8726 85.7268 40.1728 85.7268 40.1728L85.7268 40.1728C85.7268 40.1728 102.323 47.4848 135.029 35.8707C171.136 23.049 187.549 30.3036 187.604 30.3277L187.604 30.3278C187.604 30.3278 204.2 37.6398 236.906 26.0257C273.073 13.1826 289.481 20.4829 289.481 20.4829C289.481 20.4828 306.077 27.7948 338.783 16.1807C374.95 3.33764 391.358 10.6379 391.358 10.6379L384.442 -62.2283C384.442 -62.2283 361.89 -68.6262 332.106 -55.621C305.082 -43.8207 282.565 -52.3832 282.565 -52.3832L282.565 -52.3833C282.565 -52.3833 260.013 -58.7813 230.229 -45.776C203.205 -33.9757 180.688 -42.5383 180.688 -42.5383L180.688 -42.5383C180.688 -42.5383 158.136 -48.9363 128.352 -35.931C101.328 -24.1308 78.8114 -32.6933 78.8114 -32.6933L78.8114 -32.6934C78.8114 -32.6934 56.2588 -39.0913 26.475 -26.0861C-0.549258 -14.2858 -23.0656 -22.8483 -23.0656 -22.8483Z"
        fill="#144DFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.0227 0.333719L23.0396 5.06714L25.964 7.43328C27.3446 8.54081 29.3773 8.34437 30.514 6.99358L32.4339 4.712L27.0227 0.333719ZM37.5543 8.99458L32.9024 5.05083L27.7383 11.4919C26.6109 12.9072 26.8091 14.9952 28.1812 16.1584L30.3343 17.9837L37.5543 8.99458Z"
        fill="#06FFC3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4095_157324">
        <rect
          width="20.8573"
          height="16.3085"
          fill="white"
          transform="matrix(0.995363 -0.096188 0.0944808 0.995527 20.6541 2.00623)"
        />
      </clipPath>
    </defs>
  </svg>
);
